import React, { FC, useEffect } from 'react';
import { Form } from 'antd';
import { Panel } from '@shared/components';
import { ShowMoreInput } from '@shared/modules';

interface ProjectNotesProps {
  className?: string;
  siteNotes?: string | null;
  engineeringNote?: string | null;
  leasingNote?: string | null;
  permittingNote?: string | null;
  permittingLabel?: string;
}

export const ProjectNotes: FC<ProjectNotesProps> = ({
  className,
  siteNotes,
  engineeringNote,
  leasingNote,
  permittingNote,
  permittingLabel = 'Project Permitting Notes',
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    const emptyNotes = Object.fromEntries(
      Object.entries({
        siteNotes,
        engineeringNote,
        leasingNote,
        permittingNote,
      }).filter(([, note]) => !note),
    );

    form.setFieldsValue(emptyNotes);
  }, [form, siteNotes, engineeringNote, leasingNote, permittingNote]);

  return (
    <Form
      labelCol={{ span: 10 }}
      wrapperCol={{ span: 14 }}
      className={className}
      form={form}
    >
      <Panel header="Notes">
        <ShowMoreInput
          id="siteNotes"
          label="Site Notes"
          data={siteNotes}
          form={form}
          isEditing={false}
        />
        <ShowMoreInput
          id="engineeringNote"
          label="Engineering Notes"
          data={engineeringNote}
          form={form}
          isEditing={false}
        />
        <ShowMoreInput
          id="leasingNote"
          label="Leasing Notes"
          data={leasingNote}
          form={form}
          isEditing={false}
        />
        <ShowMoreInput
          id="permittingNote"
          label={permittingLabel}
          data={permittingNote}
          form={form}
          isEditing={false}
        />
      </Panel>
    </Form>
  );
};
